module.exports = __webpack_public_path__ + "static/img/banner.298e21c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner.jpg
// module id = H3BY
// module chunks = 1